const buyingOptions = {
    options: document.querySelectorAll('.jsSize'),
    model: document.querySelector('.jsModelInput'),
    img: document.querySelector('.jsThumbInput'),
    sku: document.querySelector('.jsSkuInput'),
    btnDisable: document.getElementById('addToOptions'),
    btn: document.getElementById('addToCart'),

    init() {
        if (this.options.length > 0) {
            this.setOption();
        }else{
            // this.removeDummy()
        }
        window.addEventListener('reset', () => {

            this.setWars();
            this.setOption();
        });

    },
    removeDummy() {
        if(this.btn && this.btnDisable) {
            this.btnDisable.classList.add('d-none');
            this.btn.classList.remove('d-none');
        }
      
    },   
    setWars() {    
        this.options = document.querySelectorAll('.jsSize');
        this.model = document.querySelector('.jsModelInput');
        this.img = document.querySelector('.jsThumbInput');
        this.sku = document.querySelector('.jsSkuInput');
        this.btnDisable = document.getElementById('addToOptions');
        this.btn = document.getElementById('addToCart');
        this.options.forEach(item =>  item.classList.remove('activeClass') );
    },
    setOption() {
        this.options.forEach(item => {
            item.addEventListener('click', () => {

                this.options.forEach(item =>  item.classList.remove('activeClass') );
                item.classList.add('activeClass');
                this.model.value = item.dataset.name;
                this.img.value = item.dataset.img;
                this.sku.value = item.dataset.sku;
                if(this.btnDisable){
                    this.btnDisable.classList.add('d-none');
                    this.btn.classList.remove('d-none');
                }
            
              
            });
        })
    }

}

export default buyingOptions;